import { BN, fromWei } from 'web3-utils';

const BigNumber = require('bignumber.js');
const currencyFormatter = require('currency-formatter');

/**
 * Return a properly formatted number in fiat currency.
 *
 * @param {BN} amountInWei
 * @param {string} currencyCode
 * @param {number|BigNumber} currencyExchangeRate
 * @param {string?} suffix
 *
 * @returns {string} the amount formatted for the currency.
 */
export default (amountInWei, currencyCode, currencyExchangeRate, suffix = '') => {
  if (currencyCode && currencyExchangeRate && BN.isBN(amountInWei)) {
    const rate = BigNumber(currencyExchangeRate);
    const amountInFiat = rate.times(fromWei(amountInWei));
    return `${currencyFormatter.format(amountInFiat, {
      code: currencyCode.toUpperCase(),
    })} ${suffix}`.trim();
  }
  return '--';
};



// WEBPACK FOOTER //
// ./src/utilities/weiToFiat.js